// src/components/About/AboutSection.js
import React, { useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { BiCog } from 'react-icons/bi'; // Using a gear icon similar to the star/gear in image
import AOS from 'aos';
import 'aos/dist/aos.css'; // Import AOS styles
import '../About/About.css';
import About from '../../assets/Home/About.png';

const AboutSection = () => {
  
  // Initialize Animation Library
  useEffect(() => {
    AOS.init({
      duration: 1000, // Animation speed
      once: true, // Only animate once when scrolling down
      offset: 100, // Trigger point
    });
  }, []);

  return (
    <section className="about-section" id="about">
      <Container>
        {/* ROW 1: Content & Image */}
        <Row className="align-items-center mb-5">
          
          {/* Left Column: Text Content */}
          <Col lg={7} md={12} data-aos="fade-right">
            <span className="sub-heading">About The Company</span>
            <h2 className="main-heading">
              Engineered For <span className="text-orange">Precision</span><br />
              Built For <span className="text-orange">Reliability</span>
            </h2>
            
            <p className="about-desc">
              We are an ISO-certified manufacturing company specializing in 
              precision stamping and engineered auto components. With years 
              of industry experience, we support OEMs and Tier-1 suppliers 
              with consistent quality, reliable processes, and on-time delivery.
            </p>

            {/* Features List - 2x2 Grid */}
            <Row>
              <Col sm={6}>
                <div className="feature-item">
                  <BiCog className="feature-icon" />
                  <span className="feature-text">Precision stamping and component manufacturing</span>
                </div>
              </Col>
              <Col sm={6}>
                <div className="feature-item">
                  <BiCog className="feature-icon" />
                  <span className="feature-text">Strict quality control and inspection processes</span>
                </div>
              </Col>
              <Col sm={6}>
                <div className="feature-item">
                  <BiCog className="feature-icon" />
                  <span className="feature-text">Advanced machining and assembly capabilities</span>
                </div>
              </Col>
              <Col sm={6}>
                <div className="feature-item">
                  <BiCog className="feature-icon" />
                  <span className="feature-text">Reliable delivery for OEM and automotive partners</span>
                </div>
              </Col>
            </Row>
          </Col>

          {/* Right Column: Image */}
          <Col lg={5} md={12} className="mt-4 mt-lg-0" data-aos="fade-left">
            <div className="about-img-container">
              {/* Replace with your factory image */}
              <img 
                src={About}
                alt="Factory Floor" 
                className="about-img" 
              />
            </div>
          </Col>
        </Row>

        {/* ROW 2: Circular Stats */}
        <Row className="justify-content-center mt-5">
          
          {/* Stat 1 */}
          <Col lg={3} md={6} sm={6} xs={12} data-aos="fade-up" data-aos-delay="0">
            <div className="stat-circle">
              <div className="stat-number">25<span>+</span></div>
              <div className="stat-label">Complete<br />Projects</div>
            </div>
          </Col>

          {/* Stat 2 */}
          <Col lg={3} md={6} sm={6} xs={12} data-aos="fade-up" data-aos-delay="100">
            <div className="stat-circle">
              <div className="stat-number text-orange">500<span>+</span></div>
              <div className="stat-label">Components<br />Manufactured</div>
            </div>
          </Col>

          {/* Stat 3 */}
          <Col lg={3} md={6} sm={6} xs={12} data-aos="fade-up" data-aos-delay="200">
            <div className="stat-circle">
              <div className="stat-number">50<span>+</span></div>
              <div className="stat-label">OEM & Tier-1<br />Clients</div>
            </div>
          </Col>

          {/* Stat 4 */}
          <Col lg={3} md={6} sm={6} xs={12} data-aos="fade-up" data-aos-delay="300">
            <div className="stat-circle">
              <div className="stat-number">ISO</div>
              <div className="stat-label">Certified Quality<br />Systems</div>
            </div>
          </Col>

        </Row>

     

      </Container>
    </section>
  );
};

export default AboutSection;